import { ActorAnalysis } from "./collaboration/ActorAnalysis";
import { SystemAnalysis } from "./collaboration/SystemAnalysis";
import { OrganizationAnalysis } from "./collaboration/OrganizationAnalysis";
import { EmotionalTranslator } from "./EmotionalTranslator";
export class LeaderDashboard {
    constructor(app) {
        this.app = app;
        this.currentView = 'actor';
        this.actorComponent = new ActorAnalysis(this.app);
        this.systemComponent = new SystemAnalysis();
        this.organizationComponent = new OrganizationAnalysis();
        this.translatorComponent = new EmotionalTranslator(this.app);
    }
    renderContent() {
        switch (this.currentView) {
            case 'actor': return this.actorComponent.render();
            case 'system': return this.systemComponent.render();
            case 'organization': return this.organizationComponent.render();
            case 'translator': return this.translatorComponent.render();
            default: return `<div>Invalid view selected.</div>`;
        }
    }
    updateView(view) {
        if (this.currentView !== view) {
            this.currentView = view;
            this.app.renderCurrentView();
        }
    }
    renderCurrentViewOnly() {
        var _a;
        const contentEl = document.getElementById('leader-content');
        if (contentEl) {
            contentEl.innerHTML = this.renderContent();
            document.querySelectorAll('.tab-button').forEach(btn => btn.classList.remove('active'));
            (_a = document.getElementById(`show-${this.currentView}`)) === null || _a === void 0 ? void 0 : _a.classList.add('active');
            this.attachEventListenersForContent();
        }
    }
    render() {
        return `
            <div class="card wide-card">
                <div class="leader-header">
                    <h2>The Strategic Cockpit: A Multi-Scalar View</h2>
                     <button id="return-to-dashboard" class="button-secondary button-small">Return to Dashboard</button>
                </div>
                <p class="narrative-transition">A suite of analytical instruments to move from raw data to decision-ready intelligence.</p>
                <div class="tab-buttons">
                    <button id="show-actor" class="tab-button ${this.currentView === 'actor' ? 'active' : ''}">Micro-Scale (Actor)</button>
                    <button id="show-system" class="tab-button ${this.currentView === 'system' ? 'active' : ''}">Meso-Scale (System)</button>
                    <button id="show-organization" class="tab-button ${this.currentView === 'organization' ? 'active' : ''}">Macro-Scale (Organization)</button>
                    <button id="show-translator" class="tab-button ${this.currentView === 'translator' ? 'active' : ''}">Rhetorical Engine</button>
                </div>
                <div id="leader-content" class="leader-content-area">
                    ${this.renderContent()}
                </div>
            </div>
        `;
    }
    attachEventListenersForContent() {
        switch (this.currentView) {
            case 'actor':
                this.actorComponent.attachEventListeners();
                break;
            case 'system':
                this.systemComponent.attachEventListeners();
                break;
            case 'organization':
                this.organizationComponent.attachEventListeners();
                break;
            case 'translator':
                this.translatorComponent.attachEventListeners();
                break;
        }
    }
    attachEventListeners() {
        var _a, _b, _c, _d, _e;
        (_a = document.getElementById('show-actor')) === null || _a === void 0 ? void 0 : _a.addEventListener('click', () => this.updateView('actor'));
        (_b = document.getElementById('show-system')) === null || _b === void 0 ? void 0 : _b.addEventListener('click', () => this.updateView('system'));
        (_c = document.getElementById('show-organization')) === null || _c === void 0 ? void 0 : _c.addEventListener('click', () => this.updateView('organization'));
        (_d = document.getElementById('show-translator')) === null || _d === void 0 ? void 0 : _d.addEventListener('click', () => this.updateView('translator'));
        (_e = document.getElementById('return-to-dashboard')) === null || _e === void 0 ? void 0 : _e.addEventListener('click', () => {
            this.app.returnToDashboard();
        });
        this.attachEventListenersForContent();
    }
}
